module.exports = __webpack_public_path__ + "assets/01.101e120b.pdf";